import React from "react";
import { Button, ButtonProps, Heading, Modal, ModalProps, RequiredKeys } from "@hex-insights/core";
import { Guardian, Student } from "../../../../Utilities";
import { RelationshipOnExistingForm } from "../../../Forms";
import styles from "./styles.module.css";

export type RelationshipOnStudentCreateModalControllerProps = Pick<
	ButtonProps,
	"variant" | "size" | "className" | "style" | "children"
> &
	Omit<RelationshipOnStudentCreateModalProps, "ifRef" | "onClose">;

export function RelationshipOnStudentCreateModalController({
	variant,
	size,
	className,
	style,
	children,
	...props
}: RelationshipOnStudentCreateModalControllerProps) {
	const { isModalOpen, openModal, closeModal } = Modal.useToggle();

	return (
		<React.Fragment>
			<Button variant={variant} size={size} className={className} style={style} onClick={openModal}>
				{children}
			</Button>

			<Modal.If condition={isModalOpen}>
				<RelationshipOnStudentCreateModal {...props} onClose={closeModal} />
			</Modal.If>
		</React.Fragment>
	);
}

export type RelationshipOnStudentCreateModalProps = {
	studentID: Student["id"];
} & RequiredKeys<Pick<ModalProps, "ifRef" | "onClose">, "onClose">;

export function RelationshipOnStudentCreateModal({ studentID, ifRef, onClose }: RelationshipOnStudentCreateModalProps) {
	return (
		<Modal ifRef={ifRef} onClose={onClose} className={styles["modal"]}>
			<Modal.Header>
				<Heading.H2 noMargin>Add Relationship</Heading.H2>
			</Modal.Header>
			<Modal.Body>
				<RelationshipOnExistingForm.ControlledCreateOnStudent studentID={studentID} onSuccess={onClose} />
			</Modal.Body>
		</Modal>
	);
}

export type RelationshipOnGuardianCreateModalControllerProps = Pick<
	ButtonProps,
	"variant" | "size" | "className" | "style" | "children"
> &
	Omit<RelationshipOnGuardianCreateModalProps, "ifRef" | "onClose">;

export function RelationshipOnGuardianCreateModalController({
	variant,
	size,
	className,
	style,
	children,
	...props
}: RelationshipOnGuardianCreateModalControllerProps) {
	const { isModalOpen, openModal, closeModal } = Modal.useToggle();

	return (
		<React.Fragment>
			<Button variant={variant} size={size} className={className} style={style} onClick={openModal}>
				{children}
			</Button>

			<Modal.If condition={isModalOpen}>
				<RelationshipOnGuardianCreateModal {...props} onClose={closeModal} />
			</Modal.If>
		</React.Fragment>
	);
}

export type RelationshipOnGuardianCreateModalProps = {
	guardianID: Guardian["id"];
} & RequiredKeys<Pick<ModalProps, "ifRef" | "onClose">, "onClose">;

export function RelationshipOnGuardianCreateModal({
	guardianID,
	ifRef,
	onClose,
}: RelationshipOnGuardianCreateModalProps) {
	return (
		<Modal ifRef={ifRef} onClose={onClose} className={styles["modal"]}>
			<Modal.Header>
				<Heading.H2 noMargin>Add Relationship</Heading.H2>
			</Modal.Header>
			<Modal.Body>
				<RelationshipOnExistingForm.ControlledCreateOnGuardian guardianID={guardianID} onSuccess={onClose} />
			</Modal.Body>
		</Modal>
	);
}
